/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpdateExternalOAuthServerRequestBody,
  UpdateExternalOAuthServerRequestBody$Outbound,
  UpdateExternalOAuthServerRequestBody$outboundSchema,
} from "../components/updateexternaloauthserverrequestbody.js";

export type UpdateExternalOAuthServerSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type UpdateExternalOAuthServerSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type UpdateExternalOAuthServerSecurity = {
  option1?: UpdateExternalOAuthServerSecurityOption1 | undefined;
  option2?: UpdateExternalOAuthServerSecurityOption2 | undefined;
};

export type UpdateExternalOAuthServerRequest = {
  /**
   * The slug of the toolset whose attached external OAuth server is updated
   */
  slug: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  updateExternalOAuthServerRequestBody: UpdateExternalOAuthServerRequestBody;
};

/** @internal */
export type UpdateExternalOAuthServerSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const UpdateExternalOAuthServerSecurityOption1$outboundSchema:
  z.ZodMiniType<
    UpdateExternalOAuthServerSecurityOption1$Outbound,
    UpdateExternalOAuthServerSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function updateExternalOAuthServerSecurityOption1ToJSON(
  updateExternalOAuthServerSecurityOption1:
    UpdateExternalOAuthServerSecurityOption1,
): string {
  return JSON.stringify(
    UpdateExternalOAuthServerSecurityOption1$outboundSchema.parse(
      updateExternalOAuthServerSecurityOption1,
    ),
  );
}

/** @internal */
export type UpdateExternalOAuthServerSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const UpdateExternalOAuthServerSecurityOption2$outboundSchema:
  z.ZodMiniType<
    UpdateExternalOAuthServerSecurityOption2$Outbound,
    UpdateExternalOAuthServerSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function updateExternalOAuthServerSecurityOption2ToJSON(
  updateExternalOAuthServerSecurityOption2:
    UpdateExternalOAuthServerSecurityOption2,
): string {
  return JSON.stringify(
    UpdateExternalOAuthServerSecurityOption2$outboundSchema.parse(
      updateExternalOAuthServerSecurityOption2,
    ),
  );
}

/** @internal */
export type UpdateExternalOAuthServerSecurity$Outbound = {
  Option1?: UpdateExternalOAuthServerSecurityOption1$Outbound | undefined;
  Option2?: UpdateExternalOAuthServerSecurityOption2$Outbound | undefined;
};

/** @internal */
export const UpdateExternalOAuthServerSecurity$outboundSchema: z.ZodMiniType<
  UpdateExternalOAuthServerSecurity$Outbound,
  UpdateExternalOAuthServerSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => UpdateExternalOAuthServerSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => UpdateExternalOAuthServerSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function updateExternalOAuthServerSecurityToJSON(
  updateExternalOAuthServerSecurity: UpdateExternalOAuthServerSecurity,
): string {
  return JSON.stringify(
    UpdateExternalOAuthServerSecurity$outboundSchema.parse(
      updateExternalOAuthServerSecurity,
    ),
  );
}

/** @internal */
export type UpdateExternalOAuthServerRequest$Outbound = {
  slug: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  UpdateExternalOAuthServerRequestBody:
    UpdateExternalOAuthServerRequestBody$Outbound;
};

/** @internal */
export const UpdateExternalOAuthServerRequest$outboundSchema: z.ZodMiniType<
  UpdateExternalOAuthServerRequest$Outbound,
  UpdateExternalOAuthServerRequest
> = z.pipe(
  z.object({
    slug: z.string(),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    updateExternalOAuthServerRequestBody:
      UpdateExternalOAuthServerRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      updateExternalOAuthServerRequestBody:
        "UpdateExternalOAuthServerRequestBody",
    });
  }),
);

export function updateExternalOAuthServerRequestToJSON(
  updateExternalOAuthServerRequest: UpdateExternalOAuthServerRequest,
): string {
  return JSON.stringify(
    UpdateExternalOAuthServerRequest$outboundSchema.parse(
      updateExternalOAuthServerRequest,
    ),
  );
}
